import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import WholesaleHero from './components/WholesaleHero';
import SKUTrustSection from './components/SKUTrustSection';
import BuyerSupplierSection from './components/BuyerSupplierSection';
import CategoryShowcase from './components/CategoryShowcase';
import VerificationTiers from './components/VerificationTiers';
import WholesaleCTABand from './components/WholesaleCTABand';

export default function WholesalePage() {
  return (
    <>
      <Navbar />
      <main>
        <WholesaleHero />
        <SKUTrustSection />
        <BuyerSupplierSection />
        <CategoryShowcase />
        <VerificationTiers />
        <WholesaleCTABand />
      </main>
      <Footer />
    </>
  );
}